export abstract class Serializable<T> {
  abstract deserialize(input: object): void

  /**
   * Method that checking existence of class properties in input object and do serializing after that
   * @param input object that will be serialized into class properties
   */
  protected checkAndDeserialize(input: object): void {
    if (input && Object.keys(input).length === 0) {
      // if we get empty object on input - that means we want to create empty instance of object
      // lets pass it without checking
      this.deserialize(input)
    } else if (!input) {
      // if input is undefined don't do any serialize and log to console
      console.error(
        `Cannot create instance of class ${this['constructor']['name']}, because serialized object is undefined`,
      )
    } else {
      // for each property in class
      this.deserialize(input)
    }
  }
}
